const API_BASE_URL = 'https://api.ai-mastery-hub.com/api/v1'
const apiVersion = 'v1'

let isInitialized = false

// Safe localStorage access wrapper for iOS compatibility
function safeLocalStorageGet(key: string): string | null {
    try {
        return window.localStorage.getItem(key)
    } catch (error) {
        // localStorage can throw on iOS (private browsing, quota exceeded, etc.)
        console.warn(`[Constants] localStorage.getItem('${key}') failed:`, error)
        return null
    }
}

function safeLocalStorageSet(key: string, value: string): boolean {
    try {
        window.localStorage.setItem(key, value)
        return true
    } catch (error) {
        // localStorage can throw on iOS (private browsing, quota exceeded, etc.)
        console.warn(`[Constants] localStorage.setItem('${key}') failed:`, error)
        return false
    }
}

// Initialize configuration from urls.json
export async function initConfig() {
    if (isInitialized) return

    try {
        const res = await fetch('/urls.json')
        if (!res.ok) {
            safeLocalStorageSet('apiUrl', API_BASE_URL)
            safeLocalStorageSet('apiVersion', apiVersion)
            isInitialized = true
            return
        }
        const urls = await res.json()
        if (urls.api_base_url) {
            // Use URL exactly as specified in urls.json - no manipulation
            safeLocalStorageSet('apiUrl', urls.api_base_url)
            safeLocalStorageSet('apiVersion', apiVersion)
        }
        isInitialized = true
    } catch (error) {
        console.warn('[Constants] initConfig failed:', error)
        safeLocalStorageSet('apiUrl', API_BASE_URL)
        safeLocalStorageSet('apiVersion', apiVersion)
        isInitialized = true
    }
}

export function getConfig() {
    const apiUrl = safeLocalStorageGet('apiUrl') || API_BASE_URL

    return {
        apiVersion: safeLocalStorageGet('apiVersion') || apiVersion,
        apiUrl: apiUrl,
    }
}

// Initialize immediately with proper error handling
initConfig().catch((error) => {
    console.error('[Constants] Unhandled error in initConfig:', error)
})
